/**
 * The content addresses and key segments the runtime's R2 key builders (`@wayai/runtime/r2`)
 * check, each declared once for the contract that admits it and the builder that re-checks it.
 *
 * They live apart from their contracts (`./evals`, `./call-openings`) because `@wayai/runtime`'s
 * root loads those builders in every backend Worker isolate: imported from their contracts, those
 * contracts' schemas would load in every isolate too (gh #5083, decision 61;
 * `scripts/check-backend-startup-graph.ts`). The contracts barrel exports them. Keep this module
 * free of imports.
 */

/**
 * The eval-attachment content address: sha-256, lowercase hex. ONE definition —
 * defense-in-depth means two CHECK SITES (the evals contract and the R2 key builder in
 * runtime), never two definitions that can drift apart.
 */
export const EVAL_ATTACHMENT_HASH_REGEX = /^[a-f0-9]{64}$/;

/**
 * The fixed segment 1 of every call opening's key in the resource bucket
 * (`{hub_id}/call-openings/{sha256}`): the runtime's key builder and the editor's playback
 * path both take it from here.
 */
export const CALL_OPENINGS_SEGMENT = 'call-openings';

/** An opening's content address: the sha256 of its bytes, lowercase hex — the eval attachments' own. */
export const CALL_OPENING_HASH_REGEX = EVAL_ATTACHMENT_HASH_REGEX;
